import * as React from "react";
import { observer } from "mobx-react-lite";
import { AlertCircle } from "react-feather";
import { ViewModal } from "../modals/viewModal";
import { formatStrings } from "../../utils/time";
import { Table } from "../../newcomponents/table/table";
import { DateStringColumn } from "../../newcomponents/table/columns/generic/dateString";
import { Kind } from "../../mst/base";
import { TableHeaderRefreshButton } from "../../newcomponents/table/components/RefreshButton";
import { NGButton } from "../../newcomponents/button/Button";

interface Props {
  kind: Kind;
  eventlogs: any[];
  isLoading: boolean;
  isFetching: boolean;
  fetchEventlogs: any;
  nextLink: string | undefined;
}
const EventsRaw: React.FC<Props> = ({ kind, eventlogs, isLoading, isFetching, fetchEventlogs, nextLink }) => {
  const [isModalVisible, setIsModalVisible] = React.useState(false);
  const [event, setEvent] = React.useState({});

  return (
    <>
      <Table<any>
        title={"Events"}
        data={eventlogs}
        tableId={`${kind}-eventlogs-update3`}
        headerRenderer={() => {
          return (
            <>
              <TableHeaderRefreshButton onClick={() => fetchEventlogs(true)} />
            </>
          );
        }}
        enableFilter
        hideSettings
        isLoading={isLoading}
        columns={[
          {
            id: "status",
            label: "Status (Click for details)",
            cell: ({ getValue, row }) => {
              const event = row.original;
              const value = getValue();
              return (
                <div
                  className={`flex items-center color-link cursor-pointer pr-2`}
                  onClick={() => {
                    setEvent(event);
                    setIsModalVisible(true);
                  }}
                  style={{ width: 200 }}
                >
                  {value}
                  {value === "errored" ? <AlertCircle className="color-danger h-4" /> : null}
                </div>
              );
            },
          },
          {
            id: "contextText",
            label: "Context",
            size: 600,
            enableResize: true,
          },
          DateStringColumn({ id: "lastEventTimeProcessed" }, { label: "Last Event Time", format: formatStrings.log }),
          {
            id: "eventCount",
            label: "Event Count",
          },
        ]}
      />
      {nextLink ? (
        <NGButton
          className="mt-4 w-full"
          variant="secondary"
          outlined
          onClick={() => fetchEventlogs(false)}
          loading={isFetching}
          disabled={isFetching}
        >
          More events
        </NGButton>
      ) : null}
      {isModalVisible && (
        <ViewModal
          title={"Event"}
          object={event}
          onClose={() => setIsModalVisible(false)}
          visible={isModalVisible}
          filename={`event-${(event as any).id}`}
        />
      )}
    </>
  );
};

export const Events = observer(EventsRaw);
